export default {
    en: {
        0: "Su",
        1: "Mo",
        2: "Tu",
        3: "We",
        4: "Th",
        5: "Fr",
        6: "Sa",
    },
    ru: {
        0: "Вс",
        1: "Пн",
        2: "Вт",
        3: "Ср",
        4: "Чт",
        5: "Пт",
        6: "Сб",
    },
    es: {
        0: "Do",
        1: "Lu",
        2: "Ma",
        3: "Mi",
        4: "Ju",
        5: "Vi",
        6: "Sa",
    },
    it: {
        0: "Do",
        1: "Lu",
        2: "Ma",
        3: "Me",
        4: "Gi",
        5: "Ve",
        6: "Sa",
    },
    fr: {
        0: "Di",
        1: "Lu",
        2: "Ma",
        3: "Me",
        4: "Je",
        5: "Ve",
        6: "Sa",
    },
    de: {
        0: "So",
        1: "Mo",
        2: "Di",
        3: "Mi",
        4: "Do",
        5: "Fr",
        6: "Sa",
    },
    sk: {
        0: "Ne",
        1: "Po",
        2: "Ut",
        3: "St",
        4: "Št",
        5: "Pi",
        6: "So",
    },
    cs: {
        0: "Ne",
        1: "Po",
        2: "Út",
        3: "St",
        4: "Čt",
        5: "Pá",
        6: "So",
    }
}
